module.exports = __webpack_public_path__ + "static/media/as.1cf2d4b9.svg";